import { useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { useIsAllowedPermission } from '@mint-lib/profile-helpers';

import { Box, Button, Card, CardContent, Textarea, Typography } from '@myn/mui';

import CommentModal from '../../../pages/Builder/BuilderHeader/CommentModal.jsx';
import { Version } from '../../../types/versions.js';

type IVersionCommentType = {
  item: Version;
};

const VersionComment: React.FC<IVersionCommentType> = ({ item }) => {
  const { t } = useTranslation('@myn/planning');

  const isReadOnlyUser = !useIsAllowedPermission(
    'campaignPlanningFeature:modify',
  );

  const [isOpenModal, setIsModalOpen] = useState(false);

  const handleModalClose = () => setIsModalOpen(false);
  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <Card>
        <CardContent sx={{ '&, :last-child': { padding: 1.5 } }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: 3,
              marginBottom: 1,
            }}
          >
            <Typography variant="h6">{t('Description')}</Typography>
            <Button
              onClick={handleModalOpen}
              disabled={isReadOnlyUser}
              startIcon="Edit"
              variant="outlined"
            >
              {t('Edit')}
            </Button>
          </Box>
          <Textarea
            fullWidth
            value={item.description}
            readOnly
            placeholder={t('This version has no description yet.')}
          />
        </CardContent>
      </Card>

      <CommentModal
        id={item.id}
        description={item.description}
        isOpened={isOpenModal}
        onClose={handleModalClose}
      />
    </>
  );
};

export default VersionComment;
